import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';

export default function ConfirmDialog({
    isOpen,
    msgConfirm,
    closeCallBack,
    okCallBack,
    textSubmit,
    textClose,
    className = '',
    cancelCallBack,
    textCancel,
    cancelClassName = '',
    isShowClassnameButton = true,
    disableButtonCallBack = false,
    okButtonStyle = {},
    closeButtonStyle = {},
    cancelButtonStyle = {}
}) {
    const hasOkStyle = Object.keys(okButtonStyle).length > 0;
    const hasCloseStyle = Object.keys(closeButtonStyle).length > 0;
    const hasCancelStyle = Object.keys(cancelButtonStyle).length > 0;

    return (
        <Dialog
            open={!!isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={`wrapDialog ${className}`}
        >
            <DialogContent>
                <div className="confirmPlease">{msgConfirm}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                {okCallBack && (
                    <Button
                        onClick={okCallBack}
                        variant="contained"
                        className={`${!hasOkStyle && isShowClassnameButton &&
                            'btn-hg32 btn-handle-delete-user-agree btn-handle-delete-user-agree-important'}`}
                        color={!isShowClassnameButton && !hasOkStyle ? 'primary' : 'default'}
                        disabled={disableButtonCallBack}
                        style={okButtonStyle}
                    >
                        {textSubmit ? textSubmit : I18n.get('CM-BUTTON-OK')}
                    </Button>
                )}

                {closeCallBack && (
                    <Button
                        variant="contained"
                        className={`${!hasCloseStyle && isShowClassnameButton && 'btn-light btn-hg32'}`}
                        onClick={closeCallBack}
                        color={hasCloseStyle ? 'default' : 'primary'}
                        disabled={disableButtonCallBack}
                        style={closeButtonStyle}
                    >
                        {textClose ? textClose : I18n.get('COMBTN001')}
                    </Button>
                )}

                {cancelCallBack && (
                    <Button
                        variant="contained"
                        onClick={cancelCallBack}
                        color={cancelClassName || hasCancelStyle ? 'default' : 'primary'}
                        className={cancelClassName ? cancelClassName : ''}
                        style={cancelButtonStyle}
                    >
                        {textCancel ? textCancel : I18n.get('COMBTN001')}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
